<div class="scaffold-list-holder" [ngClass]="{'horizontal-list':item.is_horizontal, 'horizontal-list-1':item.items && item.items.length == 1, 'horizontal-list-2':item.items && item.items.length == 2, 'no-wrap-list':item.prevent_wrap}">
  <div *ngFor="let el of view_array; let $i = index" class="scaffold-list-item scaffold-item-section">
    <app-rendered [info]="info" *ngFor="let it of el" [paramprefix]="(prefix ? prefix : '') + item.name + '/' + $i" [item]="it" [arr]="el"></app-rendered>
  </div>
</div>
